exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-buy-nominal[data-v-5a5d453a],.button-primary[data-v-5a5d453a]{min-width:199px;min-height:50px}.button-buy-nominal[data-v-5a5d453a]{background-color:#fff;color:#d20b12;-webkit-box-shadow:0 2px 2px #00000029;box-shadow:0 2px 2px #00000029;border-radius:4px;border:none;padding:13px 20px;text-align:center;cursor:pointer;text-decoration:none;font:normal normal 600 16px/19px Montserrat;letter-spacing:0}.bg-red[data-v-5a5d453a]{background-color:#d20b12}.button-buy-nominal[data-v-5a5d453a]:hover{background-color:#d20b12;color:#fff}.disabledBtn[data-v-5a5d453a]{opacity:.65;pointer-events:none}.fs-14[data-v-5a5d453a]{font-size:14px}.mr-45[data-v-5a5d453a]{margin-right:45px}.line-through[data-v-5a5d453a]{text-decoration:line-through;text-decoration-thickness:2px;background-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a5d453a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/app/components/BuyQuotationBtn.vue
// module id = kCFS
// module chunks = 1